import React, { useContext } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Button, CardContent, Divider, TextField } from "@mui/material";
import { Box, Stack } from "@mui/system";

import { SettingsContext } from "../settings-context";
import { useSatelliteDevices } from "./hooks/use-satellite-devices";
import SatelliteDevicesTable from "./table/table";

const SatelliteDevices = () => {
  const { roleId, regionCode } = useContext(SettingsContext);
  const satelliteDevices = useSatelliteDevices({ orgId: roleId, regionCode });
  const { startAdding, searchInput, setSearchInput, applySearch, clearSearch } =
    satelliteDevices;

  return (
    <>
      <Divider />
      <CardContent>
        <Stack direction="row" alignItems="center" gap={2}>
          <TextField
            placeholder="Search IMEI"
            variant="outlined"
            size="small"
            sx={{ width: 320 }}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                applySearch();
              }
            }}
            slotProps={{
              htmlInput: {
                "data-testid": "satellite-search-imei",
              },
            }}
          />
          <Button
            variant="contained"
            color="secondary"
            type="button"
            onClick={applySearch}
            data-testid="satellite-apply-button"
          >
            Apply
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={clearSearch}
            data-testid="satellite-clear-button"
          >
            Clear
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Button
            variant="contained"
            color="primary"
            type="button"
            startIcon={<AddIcon />}
            onClick={startAdding}
            data-testid="satellite-add-device-button"
          >
            Add Device
          </Button>
        </Stack>
        <SatelliteDevicesTable satelliteDevices={satelliteDevices} />
      </CardContent>
    </>
  );
};

export default SatelliteDevices;
